export const LIST_PLAYGROUND_MODEL_TARGETS_TOOL_NAME =
  "list_playground_model_targets";
export const SET_PLAYGROUND_MODEL_TOOL_NAME = "set_playground_model";
